<template>
    <Paper @click.native="downloadCVTemplate">
        <div class="d-flex align-items-center px-4 py-3 content shadow">
            <div class="avatar d-flex align-items justify-center mr-3">
                <BaseIcon class="black" name="file" />
            </div>
            <div class="d-flex flex-column justify-center">
                <h5 class="title heading mb-0 noselect white">
                    {{ $t('resourcesInternal.cvTemplateHeader') }}
                </h5>
                <h6 class="caption mb-0 white underline">
                    {{ $t('resourcesInternal.cvTemplateSubtitle') }}
                </h6>
            </div>
        </div>
    </Paper>
</template>

<script>
import { HIGHERED_CV_TEMPLATE } from '~/services/ResourceService';

export default {
    name: 'CVTemplateButton',
    methods: {
        downloadCVTemplate() {
            window.open(HIGHERED_CV_TEMPLATE, '_blank');
        },
    },
};
</script>

<style scoped>
.avatar {
    padding: 7px;
    border-radius: 50%;
    background-color: rgb(255, 255, 255);
}

.content {
    background-color: var(--primary);
    color: white !important;
    border-radius: var(--border-radius);
    cursor: pointer;
}

.content:hover {
    filter: brightness(92%);
}

.content:active {
    filter: brightness(88%);
}

.underline {
    text-decoration: underline;
}
</style>
